// extracted by mini-css-extract-plugin
export default {"animation":"Svg_animation__+4Gdz","gradientAnimation":"Svg_gradientAnimation__18hD0"};